module.exports = __webpack_public_path__ + "media/notification2.ede3eb8a.mp3";